<template>
  <div class="columns is-multiline">
    <div class="column is-half">
      <window title="Sliders: (more examples <a href='https://github.com/NightCatSama/vue-slider-component'
                                                target='_blank'>here</a>)"
              height="100%">
        <vue-slider ref="slider" v-bind="sliderOptions1" v-model="value1"></vue-slider>
        Value: {{value1}}
      </window>
    </div>
    <div class="column is-half">
      <window title="Sliders: (more examples <a href='https://github.com/NightCatSama/vue-slider-component'
                                                target='_blank'>here</a>)"
              height="100%">
        <vue-slider ref="slider" v-bind="sliderOptions2" v-model="value2"></vue-slider>
        Value: {{value2}}
      </window>
    </div>
    <div class="column is-half">
      <window title="Sliders: (more examples <a href='https://github.com/NightCatSama/vue-slider-component'
                                                target='_blank'>here</a>)"
              height="100%">
        <vue-slider ref="slider" v-bind="sliderOptions3" v-model="value3"></vue-slider>
        Value: {{value3}}
      </window>
    </div>
    <div class="column is-half">
      <window title="Sliders: (more examples <a href='https://github.com/NightCatSama/vue-slider-component'
                                                target='_blank'>here</a>)"
              height="100%">
        <vue-slider ref="slider" v-bind="sliderOptions4"
        v-model="sliderOptions4.value"></vue-slider>
        Value: {{sliderOptions4.value}}
      </window>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';

export default {
  data() {
    return {
      value1: 1,
      value2: 1,
      value3: 1,
      value5: 1,
      sliderOptions1: {
        eventType: 'auto',
        width: 'auto',
        height: 6,
        dotSize: 16,
        dotHeight: null,
        dotWidth: null,
        min: 0,
        max: 100,
        interval: 1,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: false,
        piecewiseLabel: false,
        tooltip: false,
        tooltipDir: 'top',
        reverse: false,
        data: null,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null,
        piecewiseStyle: null,
        tooltipStyle: null,
        labelStyle: null,
        labelActiveStyle: null,
      },
      sliderOptions2: {
        value: 1,
        width: 'auto',
        height: 8,
        dotSize: 20,
        min: 1,
        max: 25,
        interval: 4,
        disabled: false,
        show: true,
        speed: 0.3,
        reverse: false,
        lazy: true,
        tooltip: 'always',
        piecewise: true,
      },
      sliderOptions3: {
        value: '2016-10-01',
        width: '80%',
        tooltip: 'always',
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        style: {
          marginLeft: '10%',
        },
        data: [
          '2016-10-01',
          '2016-10-02',
          '2016-10-03',
          '2016-10-04',
          '2016-10-05',
          '2016-10-06',
          '2016-10-07',
        ],
        piecewiseStyle: {
          backgroundColor: '#ccc',
          visibility: 'visible',
          width: '12px',
          height: '12px',
        },
        piecewiseActiveStyle: {
          backgroundColor: '#3498db',
        },
        labelActiveStyle: {
          color: '#3498db',
        },
      },
      sliderOptions4: {
        value: [4, 200],
        width: '100%',
        height: 8,
        dotSize: 20,
        min: 0,
        max: 200,
        disabled: false,
        show: true,
        tooltip: 'always',
        tooltipDir: ['bottom', 'top'],
        piecewise: false,
        style: {
          marginBottom: '30px',
        },
        bgStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
        },
        sliderStyle: [
          {
            backgroundColor: '#f05b72',
          },
          {
            backgroundColor: '#3498db',
          },
        ],
        tooltipStyle: [
          {
            backgroundColor: '#f05b72',
            borderColor: '#f05b72',
          },
          {
            backgroundColor: '#3498db',
            borderColor: '#3498db',
          },
        ],
        processStyle: {
          backgroundImage: '-webkit-linear-gradient(left, #f05b72, #3498db)',
        },
      },
    };
  },
  components: { 'vue-slider': VueSlider },
};
</script>
